import Api from 'App/api'

export const getOfficeInfo = Api.get({
  controller: 'property_contact',
  action: 'getContactInfo',
})
